export default function getAcknowledgeEventURL(id: number): string {
  return `/notifications/events/${id}/acknowledgements`;
}
